import {ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ListService} from "../../list.service";
import {_finds, isArray, uuid} from "../../ccl-util";
import {ListControlValueAccessor} from "../list-control-value-accessor";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
    selector: 'ccl-checkboxs',
    templateUrl: './checkboxs.component.html',
    styleUrls: ['./checkboxs.component.css'],
    providers: [{provide: NG_VALUE_ACCESSOR, useExisting: CheckboxsComponent, multi: true}]
})
export class CheckboxsComponent extends ListControlValueAccessor implements OnInit, OnChanges {

    // æ¯å¦æ¾ç¤ºå¨éæé®
    @Input()
    allBtn = '';

    checkboxName = ''; // checkboxçname
    selectAll = false; // å¨éç¶æ
    indeterminate = false; // é¨åéæ©ç¶æ

    constructor(listService: ListService, cdr: ChangeDetectorRef) {
        super(listService, cdr);
        this.checkboxName = uuid('ccl-checkboxs');
    }

    // å¤é¨ Control å¼åçååæ¶ï¼å°å¼è®¾ç½®ç» checkboxs
    writeValue(value: any): void {
        let noChange = true;
        let _value = value;
        if (value !== null && value !== undefined && value !== '') {
            if (!isArray(value)) {
                _value = [String(value)];
                noChange = false;
            } else if (value.length) {
                _value = value.map(item => String(item));
                noChange = JSON.stringify(_value) === JSON.stringify(value);
            }
        } else {
            _value = [];
        }

        this.value = _value;

        if (this.dataList.length) {
            this.changeValue(_finds(this.dataList, 'value', ..._value), noChange);
        }
    }

    // å½checkboxsç»ä»¶çå¼åçååï¼å°å¼æ¨éå° Control
    changeValue(value?: any[], noChange?) {
        if (value === undefined) {
            this.onTouched && this.onTouched();
            value = this.dataList.filter(el => el.checked);
        }
        if (isArray(value)) {
            this.dataList.forEach(item => item.checked = false);
            value.forEach(item => item.checked = true);
            this.valueNameChange.emit(value.map(item => item.label));
            this.sourceValueChange.emit(value.map(item => item._source));
        }
        if (!noChange) {
            this.onChange && this.onChange(value.map(item => item.value));
        }

        if (!value) {
            this.valueNameChange.emit(null);
            this.sourceValueChange.emit(null);
        }

        if (this.dataList.every(item => item.checked === false)) {
            this.selectAll = false;
            this.indeterminate = false;
        } else if (this.dataList.every(item => item.checked === true)) {
            this.selectAll = true;
            this.indeterminate = false;
        } else {
            this.indeterminate = true;
        }
    }

    changeSelectAll(all) {
        this.dataList.forEach(item => item.checked = all);
        this.changeValue();
    }

    async ngOnInit() {
        this.initNgOnChanges = true;
        if (this.invokeService) {
            await this.loadInvokeServiceData();
            if (this.value && this.value.length) {
                this.changeValue(_finds(this.dataList, 'value', ...this.value));
            }
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
        if (this.initNgOnChanges) {
            // å¨è°ç¨ç¨æ·æ¥å£æ¶ï¼è¥åç°åæ°ååï¼åéæ°è§¦åè°ç¨
            if (changes.invokeServiceParam && this.invokeService) {
                this.loadInvokeServiceData();
            }
        }
    }

}
